import jQuery from 'jquery';
import React from "react";
import accordionList from './app/accordion-list';
import resizeGroup from './app/resizer';
import reveal from './app/reveal';
import deQueue from './app/deQueue';
import searchAutocomplete from './app/search-autocomplete';
import showLoader from './app/loader';
import showModal from './app/modal';
import highlightDownloadButton from './app/highlight-download-button';
import favoriteButton from './app/favorite-button';
import debounce from './app/debounce';
import rangeSlider from './app/range-slider';
import tabs from './app/tabs';
import videoPlayer from './app/videoPlayer'; // TODO 50kb
import toggleGroup from './app/toggleGroup';
import productListLayout from './app/productListLayoutSwitcher';
import Pikaday from 'pikaday'; // 67kb
import Cookies from 'js-cookie';
import mobileMenu from './app/mobile-menu';
import Fuse from 'fuse.js';
import SimpleLightbox from 'simple-lightbox';
import {initSearchGroup} from "./app/init-search-group";
import {initMaxItems} from "./app/max-items";
import {initDataHref} from "./app/data-href";

window.$ = window.jQuery = jQuery;
window.showLoader = showLoader;
window.showModal = showModal;
window.debounce = debounce;

jQuery('html').removeClass('no-js').addClass('js');

reveal();
scroll();
deQueue();
productListLayout(() => doResize());
mobileMenu();

document.querySelectorAll('.tabs')
	.forEach(tab => tabs(tab));

document.querySelectorAll('.element--accordion-list')
	.forEach(el => accordionList(el));

document.querySelectorAll('.element--video')
	.forEach(el => videoPlayer(el, el.dataset.videoUrl, el.dataset.imageUrl));

document.querySelectorAll('.element--range-slider')
	.forEach(el => rangeSlider(el));

document.querySelectorAll('#search-widget')
	.forEach(el => searchAutocomplete(el));

document.querySelectorAll('.product--favorite-button')
	.forEach(el => favoriteButton(el));

document.querySelectorAll('[data-toggle-group]')
	.forEach(el => toggleGroup(el));

document.querySelectorAll('[data-toggle-class]').forEach(el => {
	el.addEventListener('click', () => {
		el.classList.toggle(el.dataset.toggleClass);
	});
});

document.addEventListener('click', (event) => {
	if (event.target.matches('a.loading-trigger, button.loading-trigger, input.loading-trigger')) {
		showLoader(event.target.closest('.show-loader'));
	}
});

document.addEventListener('change', (event) => {
	if (event.target.matches('select.loading-trigger')) {
		showLoader(event.target.closest('.show-loader'));
	}
});

document.addEventListener('submit', (event) => {
	if (event.target.matches('form.loading-trigger')) {
		showLoader(event.target.closest('.show-loader'));
	}
});

new SimpleLightbox({
	elements: document.querySelectorAll('a.imagezoom')
});

// replaces src of non-loadable images with the url in data-not-found attribute
jQuery('img[data-not-found]').each(function() {
	const imgEl = this;

	if(jQuery(imgEl).complete && imgEl.naturalWidth === 0) {
		// console.log('complete + no-width', imgEl);
		imgEl.src = imgEl.dataset.notFound;
	}

	jQuery(imgEl).on('error', function() {
		// console.log('onError', imgEl);
		imgEl.src = imgEl.dataset.notFound;
	});
});

(function () {
	// If no schema was set via cookie, try to guess if the browser's/system's current color schema
	if(Cookies.get('color-schema') !== 'light' && Cookies.get('color-schema') !== 'dark' && window.matchMedia) {
		try {
			const isDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;
			const colorSchema = isDarkMode ? 'dark' : 'light';
			setColorSchema(colorSchema);
		} catch (e) {
			console.error(e);
		}
	}

	jQuery('#switch-theme-button').click(e => {
		e.stopPropagation();
		const colorSchema = Cookies.get('color-schema') === 'dark' ? 'light' : 'dark';
		setColorSchema(colorSchema);
	});

	function setColorSchema(colorSchema) {
		Cookies.set('color-schema', colorSchema);
		jQuery('link[data-theme-light]').each(function () {
			jQuery(this).attr('href', jQuery(this).data('theme-' + colorSchema));
		});
		jQuery('body').removeClass(`color-scheme-${colorSchema === 'light' ? 'dark' : 'light'}`).addClass(`color-scheme-${colorSchema}`);
	}
})();

jQuery('input.datepicker').each(function() {
	const input = this;
	new Pikaday({
		field: input,
		format: 'DD.MM.YYYY',
		firstDay: 1
	});
});

if(navigator.share) {
	jQuery('[data-share]').each(function() {
		const shareEl = $(this);
		const shareData = shareEl.data('share');

		shareEl.click(async function() {
			await navigator.share(shareData);
		});
	});
}

jQuery(function($) {
	setTimeout(doResize, 250);
	$(window).on('resize', debounce(doResize, 200));
});

document.querySelectorAll('.debug-pencil').forEach(el => {
	el.addEventListener('mouseover', () => el.parentElement.classList.add('debug-region'));
	el.addEventListener('mouseout', () => el.parentElement.classList.remove('debug-region'));
});

function doResize() {
	let groups = {};
	jQuery('*[data-resize-group]').each(function() {
		const group = $(this).data('resize-group');

		if(!groups.hasOwnProperty(group)) {
			groups[group] = {
				resizeSelectors: $(this).data('resize-selectors'),
				elements: []
			};
		}

		groups[group].elements.push($(this));
	});

	$.each(groups, function() {
		let elements = this.elements;
		$.each(this.resizeSelectors, function () {
			resizeGroup(elements, this);
		});
	});
}

highlightDownloadButton();
initMaxItems();
initDataHref();
initSearchGroup();
